/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';
import ContentLoader from "react-content-loader";
import {SkeletonSettings} from "../../../../../atoms/effects/skeletons/utils/SkeletonSettings";

export const InvoiceRowSkeleton = (props) => (
    <ContentLoader
        width={"100%"}
        height={80}
        speed={SkeletonSettings.SPEED}
        backgroundColor={SkeletonSettings.BACKGROUND}
        foregroundColor={SkeletonSettings.FOREGROUND}
        style={{borderTop: SkeletonSettings.BORDER}}
        {...props}>

        {/* Invoice date */}
        <rect x="0" y={`calc(50% - 5px)`} rx="3" ry="3" width="10%" height="10"/>

        {/* Billing document */}
        <rect x="15%" y={`calc(50% - 5px)`} rx="3" ry="3" width="10%" height="10"/>

        {/* Accounting document */}
        <rect x="30%" y={`calc(50% - 5px)`} rx="3" ry="3" width="10%" height="10"/>

        {/* Invoice amount */}
        <rect x="45%" y={`calc(50% - 5px)`} rx="3" ry="3" width="10%" height="10"/>

        {/* Due date */}
        <rect x="60%" y={`calc(50% - 5px)`} rx="3" ry="3" width="10%" height="10"/>

        {/* Status */}
        <rect x="75%" y={`calc(50% - 5px)`} rx="3" ry="3" width="10%" height="10"/>

        {/* Download */}
        <rect x="90%" y={`calc(50% - 5px)`} rx="3" ry="3" width="10%" height="10"/>

    </ContentLoader>
)
